// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.in-year-budget-requests {
  background-color: #f3f5f7;
  height: 100%;
  margin-left: 1.6rem;
  margin-right: 1.6rem;
}
.in-year-budget-requests .icon-add {
  font-size: 2.08rem;
  padding-right: 6px;
  position: relative;
}
.in-year-budget-requests a.button-edit {
  cursor: pointer;
  color: rgb(0, 120, 220) !important;
}
.in-year-budget-requests .table-row {
  margin-top: 1.6rem;
}
.in-year-budget-requests .load-card {
  background-color: white;
  margin: 32px 0;
  border-radius: 4px;
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.16);
}
.in-year-budget-requests__actions {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.in-year-budget-requests__actions__filter {
  display: flex;
  gap: 20px;
}
.in-year-budget-requests__actions__filter__input {
  width: 350px;
}
.in-year-budget-requests__actions__button {
  margin-bottom: 17px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
